import { MutationCache, QueryCache, QueryClient } from 'react-query';
import { RESPONSE_CODES } from '../../constants/responseCodes.constants';
export * from 'react-query';

export const handleApiError = (e: any) => {
    const apiMessage = e?.response?.data?.message;
    if (typeof apiMessage === 'string' && apiMessage.trim().length > 0) {
        return RESPONSE_CODES[apiMessage] || apiMessage;
    }

    if (Array.isArray(apiMessage) && apiMessage.length > 0) {
        return apiMessage.join('; ');
    }

    if (typeof e?.message === 'string' && e.message.trim().length > 0) {
        if (e?.response?.status === 400) {
            return 'Some settings are invalid. Please review your inputs and try again.';
        }
        return e.message;
    }

    return RESPONSE_CODES.NO_MAP_ERROR || RESPONSE_CODES.UNKNOWN;
}

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: true,
            retry: false,
        },
    },
    queryCache: new QueryCache({
        onError: async (error: any) => {
            return handleApiError(error);
        },
    }),
    mutationCache: new MutationCache({
        onError: async (error: any) => {
            return handleApiError(error);
        },
    }),
});
